export enum RowSelection {
  SINGLE = "single",
  MULTIPLE = "multiple",
}
